export default {
  getCoockie(name) {
    let matches = document.cookie.match(new RegExp(
      '(?:^|; )' + name.replace(/([.$?*|{}()[]\/+^])/g, '\\$1') + '=([^;]*)'
    ))
    let utmObj = matches ? JSON.parse(decodeURIComponent(matches[1])) : null
    console.log(utmObj, 'get')
    return utmObj
  },
  setCoockie(name, obj, expTime) {
    let cookie = encodeURIComponent(name) + '=' + encodeURIComponent(JSON.stringify(obj))
    if (expTime) {
      cookie += '; expires=' + expTime.toGMTString()
    }
    document.cookie = cookie
    console.log(JSON.parse(JSON.stringify(obj)), 'set')
  },
  uuid() {
    function s4() {
      return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1)
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
  },
  isEmpty(v) {
    return !!(v == null || v.length === 0)
  }
}
